import { MouseEvent, useState } from 'react';

import { cn } from '@/utils/cn';

import LightTooltip from '../atoms/LightTooltip';

interface Props {
	text: string;
	className?: string;
}

const ApprovalDetailingTableCell = ({
	text,
	className,
}: Props) => {
	const [tooltipEnabled, setTooltipEnabled] = useState(false);

	const handleShouldShow = ({ currentTarget }: MouseEvent<Element>) => {
		if (currentTarget.scrollHeight > currentTarget.clientHeight) {
			setTooltipEnabled(true);
		}
	};

	return (
		<LightTooltip
			title={
      <div className="p-2 flex flex-col gap-3">
        <span className="text-xs text-[#193CB9]">Descrição</span>
        <span className="text-xs text-[#4A4A4A] font-normal">{text}</span>
      </div>}
			open={tooltipEnabled}
			onClose={() => setTooltipEnabled(false)}
			arrow
			placement="bottom-end"
		>
      <p
        onMouseEnter={handleShouldShow}
        className={cn(
          'line-clamp-2 text-[12px] my-2 text-[#4A4A4A] font-normal',
          className || '',
        )}
      >
        {text}
      </p>
		</LightTooltip>
	);
};

export default ApprovalDetailingTableCell;
